<template>
    <div class="loginForm">
        <div class="container">
            <div class="imageContainer">
                <div class="version">{{this.wdm.version}}</div>
                <div class="error" id="error" v-html="errorText"></div>
            </div>
        </div>
        <div class="loginContainer">
            <div class="kundelogin">Kundelogin</div>
            <form>
                <input v-model="user" class="loginField" placeholder="Indtast brugernavn" type="text" id="user" />
                <input @keyup.enter="submit" v-model="password" class="loginField" placeholder="Indtast password" autocomplete="true" type="password" id="password" />
            
                <div class="loginCogB">
                <label class="loginCheck">Husk mig
                    <input v-model="huskmig" type="checkbox" id="huskmig"/>
                    <span class="checkmark"></span>
                </label>
                <div @click="submit" class="loginButton">LOG IND</div>
                </div>
            </form>
        </div>
    </div>
    <div style="margin: 20px auto auto auto;font-size: 24px;" v-if="showMobileVersionSelector">
        <wdmSmallCheckmark :modelValue="showMobileVersion" title="Start mobilversion" @click="showMobileVersion=!showMobileVersion"/>
    </div>
 
    
</template>

<script>
import wdmSmallCheckmark from '@/components/wdmSmallCheckmark.vue'

export default {
  
    name: 'LoginPage',
    inject:[ 'wdm'],
    components: {wdmSmallCheckmark},
    data() { 
        return {
            user     : '',
            password : '',
            huskmig  : false,
            token : '',
            refreshToken: '',
            errorText: '',
            redirectURL: '/boxapp',
            screenWidth: window.screen.width, 
            screenHeight: window.screen.height,
            maxBrowserWidth: window.screen.availWidth, 
            maxBrowserHeight: window.screen.availHeight,
            browserWidth: document.documentElement.clientWidth, 
            browserHeight: document.documentElement.clientHeight,
            showMobileVersion: false,
            showMobileVersionSelector: (window.screen.width<500),
        }
    },
  created() {
    if (localStorage.getItem('showMobileVersion')===null) {
        if (window.screen.width<501) localStorage.setItem('showMobileVersion', 'false' )
    } else {
        this.showMobileVersionSelector = true
        this.showMobileVersion = (localStorage.getItem('showMobileVersion')=='true')
    }
        
    const params = new Proxy(new URLSearchParams(window.location.search), {
              get: (searchParams, prop) => searchParams.get(prop),
        });
    if (params.redirect) { this.redirectURL = params.redirect } 

    this.huskmig = (localStorage.getItem('save')=='true')
    if (this.huskmig) {
      
       this.refreshToken = localStorage.getItem('refreshToken')

    }
    this.token = sessionStorage.getItem('userToken')
    
    if (this.token) window.location.replace(this.redirectURL)

    if (this.refreshToken && this.huskmig) {
        this.user = String(this.parseJwt(this.refreshToken).sub).trim()
        const jwtExpiration = this.parseJwt(this.refreshToken).exp
        const now = Math.round(new Date().getTime()/1000)
        var diff = jwtExpiration - now
        //30 days = 2592000
        if (diff < 300 ) {
            this.password = ''
            this.huskmig = false
            this.refreshToken = ''
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('save')
        } else {
            this.password = '***********'
            localStorage.setItem('user', this.user)
        }      
    }

  },
  updated() {
    localStorage.setItem('showMobileVersion', (this.showMobileVersion ? 'true' : 'false'))
  },
  mounted() { 
        window.addEventListener('resize', this.getDimensions);
    },
    unmounted() {
        window.removeEventListener('resize', this.getDimensions);
    },
  methods : {
  getDimensions() {
            this.screenWidth =  window.screen.width;
            this.screenHeight = window.screen.height;
            this.maxBrowserWidth = window.screen.availWidth, 
            this.maxBrowserHeight = window.screen.availHeight,
            this.browserWidth = document.documentElement.clientWidth
            this.browserHeight = document.documentElement.clientHeight
                  
    },
    submit() {

        if (this.user != localStorage.getItem('user')) {
            localStorage.removeItem('currentUser')
            if (this.password.includes('**********')) this.password = 'x'
        }

        if (this.user && this.password) this.getToken()
    },
    parseJwt(token){
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        return JSON.parse(jsonPayload);
      
    },
    async getToken() {
        var res = ''

        if (this.password.includes('**********')) {
            
            const headers   = { "Content-Type": "application/x-www-form-urlencoded" } 
            const body = "refresh_token="+this.refreshToken
            res = await fetch( '/api/dp/login/token', { "method": "POST", "headers": headers, "body" : body } )
        } else {
            const headers   = { "Content-Type": "application/json" } 
            const body = JSON.stringify({ "user" : this.user, "password":this.password })
            res = await fetch( '/api/dp/login', { "method": "POST", "headers": headers, "body" : body } )
        }
        this.password = '**********'
        if (res.ok) { 
                console.log('successful login/renew')
                document.getElementById("error").style.display = "none";
                var resultat = await res.json()

                sessionStorage.setItem('userToken', resultat.token)
                sessionStorage.setItem('refreshToken', resultat.refreshToken)
                localStorage.setItem('user', this.user)
                if (this.huskmig) {
                    localStorage.setItem('refreshToken', resultat.refreshToken)
                    localStorage.setItem('save', this.huskmig)
                } else {
                    localStorage.removeItem('refreshToken')
                    localStorage.removeItem('save')
                }
                if (this.showMobileVersion && this.redirectURL == '/boxapp') this.redirectURL = '/boxapp/#/mobilemenu'
                window.location.replace(this.redirectURL); 
            } else if (res.status==406) {
                this.errorText='Forkert brugernavn<br>eller kodeord.'
                document.getElementById("error").style.display = "block";
                this.password =''
            } else if (res.status==403) {
                this.errorText='Dine gemte konto informationer er ugyldige.'
                document.getElementById("error").style.display = "block";
                this.password = ''
                this.huskmig = false
                this.refreshToken = ''
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('save')
            } else if (res.status==502) {
                this.errorText='(502) Serveren svarer ikke... prøv om 5 minutter, eller ring til kundeservice.'
                document.getElementById("error").style.display = "block";
            } else if (res.status==500) {
                this.errorText='(500) Serveren har det ikke så godt... prøv om 5 minutter, eller ring til kundeservice.'
                document.getElementById("error").style.display = "block";
            } else if (res.status==451) {
                this.errorText='Brugeren: '+this.user+'<br>har ikke adgang til dette site.'
                document.getElementById("error").style.display = "block";
                this.password =''
            } else {
                const resJson = await res.json()
                if (resJson.status==451) {
                    this.errorText='Brugeren: '+this.user+'<br>har ikke adgang til dette site.'
                    this.password =''
                } else {
                    this.errorText='Det ser ud til at serveren er lukket.<br>Vent et par minutter...<br>Prøv så at logge ind igen.<br>(error '+String(res.status)+'/'+String(resJson.status)+')'
                }
                document.getElementById("error").style.display = "block";
            }
    }
  }
};

</script>

<style scoped>
.version {
    color: grey;
    text-align: left;
    font-size: 8px;
    padding-left:2px;
}
.error {
    position:absolute;
    background-color:rgba(255, 0 , 0, 0.7);
    border: 3px solid;
    color: white;
    border-color: red;
    min-height:     100px;
    top: 150px;
    left: calc((100%)/2 - 160px);
    margin: auto;
    width: 300px;
    vertical-align: middle;
    font-size: 25px;
    font-weight: bold;
    padding: 10px;
    border-radius: 25px;
    display: none;
}

.loginCogB {
    margin: auto;
    display: inline-flex;
    width: 325px;
    height: 75px;
}
.loginCheck {
  margin-top: 15px;
  width: 120px;
  position: absolute;
  padding-top: 9px;
  padding-left: 30px;
  padding-right: 20px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 3px;
  height: 35px;
  margin-left: 20px;
}

/* Hide the browser's default checkbox */
.loginCheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  transition: 1.3s;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 15;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid;
  
}

/* On mouse-over, add a grey background color */
.loginCheck:hover input ~ .checkmark {
    border-color: grey;
}

/* When the checkbox is checked, add a blue background */
.loginCheck input:checked ~ .checkmark {
  background-color: #FFFFFF;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.loginCheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.loginCheck .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid var(--nomeco-green);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.loginButton {
    margin-left: 200px;
    margin-top: 10px;
    text-align: center;
    width: 100px;
    height: 20px;
    border-radius: 25px;
    background-color: var(--nomeco-lightgreen);
    border: 0px;
    color: black;
    font-weight: bold;
    font-size: 15px;
    padding:15px;
    opacity: 1;
    transition: 0.3s;
    cursor: pointer;
}

.loginButton:hover {
    opacity: 0.6;
}
.loginForm {
    min-height: 520px;
    background-image: url('@/assets/Site-ONE-org_1.webp');
    background-position: top;
    background-repeat: no-repeat;
    background-size:auto;
    
}

.loginContainer {
    
    color: white;
    background-color: var(--nomeco-green);
    height:170px;
    width: calc(100% - 120px); 
    text-align:  left;
    padding: 20px;
    padding-left: 100px;
}

.kundelogin {
    font-size: 30px;
    font-weight: bold;
    margin: 0px;
    margin-bottom: 20px;
    padding:0px;
}
.loginField {
    padding-left: 10px;
    position:unset;
    height: 50px;
    width: 270px;
    font-size: 16px;
    border: 1px solid;
    border-color: lightgrey;
    border-radius: 3px;
}
.container {
    margin: 0px;
    width: calc(100vh-1px);
    
}
.loginImage {
    width: 100vh;
    max-height:300px;
    

}
.imageContainer {

    height: 350px;

}



@media screen and (max-width: 880px) {
    
    .loginForm {
        height: 400px;
    }

    .imageContainer {
        height: 300px;
        padding:0px;
    }

    .loginContainer {
        height: 250px;
        padding-left: 10px;
        width: calc(100% - 30px)
    }
    .loginField {
        width: 360px;
        padding-left: 20px;
       
    }
}

@media screen and (max-width: 745px) { 

.loginField {
    width: 340px;
   
}

}

@media screen and (max-width: 500px) { 

    .loginForm {
        height: 500px
    }

    .loginField {
        width: 290px;
    }

    .loginButton {
    margin-left: 225px;
    }

    .loginForm {
    background-size: 200% 50%;

    }

    .imageContainer {
    height: 220px;

}

    .error {
        top: 60px;
    }

}
</style>